import {
  TEST_ORIGIN,
  PROD_ORIGIN,
  HELP_TEST_ORIGIN,
  HELP_PROD_ORIGIN
} from '@/common/constant';

/**
 * 判断是否本地开发环境
 */
export function isDev() {
  return process.env.NODE_ENV === 'development';
}

/**
 * 判断是否测试环境
 */
export function isTest() {
  return process.env.NODE_MODE === 'test';
}

/**
 * 获取url上的参数
 * @param {*} name
 */
export function getURIParam(name) {
  const reg = new RegExp('(^|\\?|&)' + name + '=([^&^#]*)(\\s|&|$|#)', 'i');
  if (reg.test(location.href)) {
    return unescape(RegExp.$2.replace(/\+/g, ' '));
  }
  return '';
}

/**
 * 拼接出搜索页的链接
 */
export const getSearchUrl = keyword => {
  keyword = keyword.replace(/ /g, '-').toLowerCase();
  return `/help-center/search/${encodeURIComponent(keyword)}/`;
};
/*
  防抖
  @param fn function
  @param wait number
  @return function
*/
export function debounce(fn, wait) {
  let timeout = null;

  return function() {
    let context = this;
    let args = arguments;

    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      timeout = null;
      fn.apply(context, args);
    }, wait);
  };
}

// 获取url上的query
export function search2Query(search) {
  const query = {};

  if (!search) return query;

  if (search.indexOf('?') === 0) {
    search = search.slice(1);
  }

  search.split('&').forEach(item => {
    const arr = item.split('=');
    if (!!arr[1]) {
      query[arr[0]] = arr[1];
    }
  });

  return query;
}

// 将query拼接成search
export function query2Search(query, prefix = '?') {
  if (
    !query ||
    !Object.keys(query).length ||
    !Object.keys(query).filter(key => query[key]).length
  )
    return '';
  return (
    prefix +
    Object.keys(query)
      .filter(key => query[key])
      .map(key => `${key}=${query[key]}`)
      .join('&')
  );
}

// 正则转义
export const escapeRegExp = string => {
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = new RegExp(reRegExpChar.source);
  return string && reHasRegExpChar.test(string)
    ? string.replace(reRegExpChar, '\\$&')
    : string;
};

// 设置高亮
export const highlight = (keyword, html) => {
  if (!keyword) {
    return escapeRegExp(html);
  }
  return html.replace(new RegExp(keyword, 'ig'), function(str) {
    return '<font class="highlight">' + str + '</font>';
  });
};

// 转换大搜返回的数据
export const mapAcademyResources = resources => {
  const res = [];
  if (!resources || !resources.length) return res;

  resources.forEach(item => {
    const { more_obj: more, post_video_obj: postVideo, ...rest } = item;
    const newItem = { ...rest };

    if (more) {
      newItem['more'] = more;
    }
    if (postVideo) {
      newItem['post_video'] = postVideo;
    }

    res.push(newItem);
  });

  return res;
};

/**
 * 获取视频跳转地址
 * @param {*} data 视频卡片item的数据
 */
export function getVideoHrefObj(data) {
  if (!data) return {};
  let url = '';
  let target = '_blank';
  if (data.status === 0 || data.status === 2) {
    url = 'javascript:;';
    target = '_self';
  } else if (data.post_id || data.id) {
    // url = `/academy/${data.more.slug}/${data.post_id || data.id}/`;
    url = `/${data.more.slug}/${data.post_id || data.id}/`;
  }
  // url = isDev() || isTest() ? `${TEST_ORIGIN}${url}` : `${PROD_ORIGIN}${url}`;

  url = isDev()
    ? `${location.origin}${url}`
    : isTest()
    ? `${HELP_TEST_ORIGIN}${url}`
    : `${HELP_PROD_ORIGIN}${url}`;
  return { url, target };
}

/**
 * 获取问答详情地址
 * @param {*} data 视频卡片item的数据
 */
// export function getTipsJumpUrl(data) {
//   let url = '';
//   // url = `/academy/${data.more && data.more.slug}-quick-tutorials-${data.id}/`;
//   url = `/${data.more && data.more.slug}-quick-tutorials-${data.id}/`;
//   url = isDev()
//     ? `${location.origin}${url}`
//     : isTest()
//     ? `${HELP_TEST_ORIGIN}${url}`
//     : `${HELP_PROD_ORIGIN}${url}`;
//   return { url, target: '_blank' };
// }

/**
 * 获取视频跳转地址
 * @param {*} data 视频卡片item的数据
 */
export function getHelpVideoHrefObj(data) {
  if (!data) return {};
  let url = '';
  let target = '_blank';
  if (data.status === 0 || data.status === 2) {
    url = 'javascript:;';
    target = '_self';
  } else if (data.post_id || data.id) {
    // url = `/academy/help-center/course/${data.id}/`;
    url = `/help-center/course/${data.id}/`;
  }
  // url = isDev() || isTest() ? `${TEST_ORIGIN}${url}` : `${PROD_ORIGIN}${url}`;
  url = isDev()
    ? `${location.origin}${url}`
    : isTest()
    ? `${HELP_TEST_ORIGIN}${url}`
    : `${HELP_PROD_ORIGIN}${url}`;
  return { url, target };
}

/**
 * 获取问答详情地址
 * @param {*} data 视频卡片item的数据
 */
export function getHelpTipsJumpUrl(data) {
  let url = '';
  // url = `/academy/help-center/tips/${data.id}/`;
  url = `/help-center/tips/${data.id}/`;
  url = isDev()
    ? `${location.origin}${url}`
    : isTest()
    ? `${HELP_TEST_ORIGIN}${url}`
    : `${HELP_PROD_ORIGIN}${url}`;
  return { url, target: '_blank' };
}

/**
 * 转换时间格式为 Jan 23, 2021
 */
export function getDateMDY(time) {
  if (!time) return '';
  const DATE_MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  // 转换成毫秒
  const len = `${time}`.length;
  time = time * Math.pow(10, 13 - len);
  const dateObj = new Date(time);
  const month = dateObj.getMonth();
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();
  return `${DATE_MONTHS[month]} ${day}, ${year}`;
}

/**
 * 获取视频卡片的背景图路径
 * @param {*} data 视频卡片item的数据 / 背景图类型
 */
export function getCourseBackgroundUrl(data, isBig) {
  if (!data) return '';

  let type = '';
  // 兼容类型及数据的传参
  if (typeof data === 'string') {
    type = data;
  } else {
    type = getCourseBackgroundType(data);
  }
  let url = `//d3mkpw26g447am.cloudfront.net/static/cover/${type}_v2.png`;
  if (isBig) {
    url = `//d3mkpw26g447am.cloudfront.net/static/cover/big_${type}.png`;
  }
  return url;
}

export function toFixed(number, limit = 2) {
  if (!number) return number;

  return parseFloat(number).toFixed(limit);
}

/**
 * @method 给数字加千位分隔符
 * @param {*} num
 */
const numFormat = num => {
  return num.toString().replace(/\d+/, function(n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function($1) {
      return $1 + ',';
    });
  });
};

// 转换人数
export function translateCrowd(number) {
  if (number >= 1000000) {
    return toFixed(number / 1000000, 1) + 'M';
  } else if (number >= 1000) {
    return toFixed(number / 1000, 1) + 'K';
  } else if (number < 1000) {
    return numFormat(number);
  }

  return number;
}

/**
 * 判断元素是否在页面中可见
 */
export function isEleVisible({
  ele,
  windowHeight,
  scrollTop,
  extraOffsetTop = 0 // 父容器的补充偏移量
}) {
  if (!ele) return false;
  let { offsetTop } = ele;
  offsetTop = offsetTop + extraOffsetTop;
  windowHeight = windowHeight === undefined ? window.innerHeight : windowHeight;
  scrollTop =
    scrollTop === undefined
      ? Math.abs(document.querySelector('._H_scorll_container').scrollTop)
      : scrollTop;
  return offsetTop >= scrollTop && offsetTop < scrollTop + windowHeight;
}



// WEBPACK FOOTER //
// ./src/utils/index.js